import * as React from 'react';

import { TreeNodeRenderFunction } from './types';

type ContextState = {
  renderNode: TreeNodeRenderFunction;
};

export const TreeContext = React.createContext<ContextState>({
  renderNode: () => null,
});

export const useTreeContext = () => React.useContext(TreeContext);
